<div class="container" *ngIf="productData?.length > 0">
  <mat-accordion>
    <mat-expansion-panel
      class="mat-elevation-z0 product-expansion-panel"
      *ngFor="let item of productData; let i = index"
      [expanded]="i === 0"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="qa-title">
          {{ item.title }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="context">
        <div [innerHTML]="item.value | safeHtml"></div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
